import { useState } from "react";
import { toast } from "sonner";
import { FileUp, Loader2 } from "lucide-react";
import { uploadFile, errMsg } from "@/lib/api";

export default function FileUpload({ fileName, onUploaded, testid = "file-upload-input", accept = "application/pdf,image/png,image/jpeg,image/webp,.docx" }) {
  const [busy, setBusy] = useState(false);
  const onChange = async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    setBusy(true);
    try {
      const res = await uploadFile(f);
      onUploaded(res);
      toast.success("File terunggah");
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <label className="flex items-center gap-3 rounded-md border border-dashed border-slate-300 bg-slate-50 px-4 py-3 cursor-pointer hover:border-amber-400 transition-colors duration-200">
      {busy ? <Loader2 className="h-4 w-4 animate-spin text-amber-500" /> : <FileUp className="h-4 w-4 text-amber-500" />}
      <span className="text-sm text-slate-600 truncate">{busy ? "Mengunggah..." : fileName || "Pilih file (PDF/JPG/PNG/DOCX, maks 20MB)"}</span>
      <input type="file" className="hidden" accept={accept} onChange={onChange} data-testid={testid} />
    </label>
  );
}
